export default __webpack_public_path__ + "static/media/bestof_1.fbfe6036.jpg";